import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { memoize } from 'lodash';
import type { Season } from './models.ts';

const isActiveCached = (season?: Season): boolean => !!(season?.end_date && dayjs().isBefore(dayjs(season.end_date)));

export const isActive = memoize(isActiveCached, season => `${season?.end_date}`);

export const isSelectedSeasonInactive = (seasons: Season[] | undefined, selectedSeasonIds: string[]): boolean => {
  if (!seasons?.length || selectedSeasonIds.length !== 1) return false;
  const selectedSeason = seasons.find(season => season.id === selectedSeasonIds[0]);
  if (!selectedSeason) return false;
  return !isActive(selectedSeason);
};

export const isDayDisabledBySeasonRange = (currentDate: Dayjs, seasonRange?: [Dayjs, Dayjs]): boolean => {
  if (currentDate.isAfter(dayjs(), 'day')) return true;
  if (!seasonRange) return false;
  return currentDate.isBefore(seasonRange[0], 'day') || currentDate.isAfter(seasonRange[1], 'day');
};
